import { ReactNode } from 'react';

interface LLSwitchProps {
  children: ReactNode;
  automationId?: string;
}

const LLSwitch: React.FC<
  React.InputHTMLAttributes<HTMLInputElement> & LLSwitchProps
> = ({ children, id, checked, disabled, onClick, onChange, automationId }) => {
  return (
    <div className="form-check form-switch d-flex gap-2 align-items-center">
      <input
        className="form-check-input"
        type="checkbox"
        id={id}
        checked={checked}
        disabled={disabled}
        onClick={onClick}
        onChange={onChange}
        automation-id={automationId}
      />
      <label className="form-check-label" htmlFor={id}>
        {children}
      </label>
    </div>
  );
};

export default LLSwitch;
